module.exports = __webpack_public_path__ + "be49eb3a6887c795884731c6b20adb2f.svg";